import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntitlementsLoadedService {
  private entitlementsLoadedSubject = new ReplaySubject<boolean>(1);
  entitlementsLoadedEvent$ = this.entitlementsLoadedSubject.asObservable();

  private usernameLoadedSubject = new ReplaySubject<boolean>(1);
  usernameLoadedEvent$ = this.usernameLoadedSubject.asObservable();

  emitEntitlementsLoadedEvent(flag: boolean) {
    this.entitlementsLoadedSubject.next(flag);
  }

  emitUsernameLoadedEvent(flag: boolean) {
    this.usernameLoadedSubject.next(flag);
  }
}